import { connect } from 'react-redux';
import SignOut from './SignOut';

import { setSignOutIsVisible } from './actions';
import { setAuthToken } from '../../common/auth/actions';


const mapStateToProps = state => ({
    isVisible: state.signOutUI.isVisible,
    setAuthToken,
    setSignOutIsVisible,
});

const mapDispatchToProps = dispatch => ({
    setAuthToken: () => dispatch(setAuthToken()),
    setSignOutIsVisible: isVisible => dispatch(setSignOutIsVisible(isVisible)),
});


export default connect(mapStateToProps, mapDispatchToProps)(SignOut);



// WEBPACK FOOTER //
// ./src/containers/Inputs/SignOut/index.js